<mat-card>
  <mat-card-header>
    <mat-card-title>Gestión de {{'Pedido' | translate}}</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>
    <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>

    <div *ngIf="!isSearching">

      <!-- Creacion de pedido -->
      <ng-container *ngIf="!(item?.Id > 0)">

        <form [formGroup]="formGroup" *ngIf="pedidoPermisos?.CanEdit">

          <mat-expansion-panel [expanded]="true" hideToggle="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-right: 5px;">settings</mat-icon>Datos del Pedido
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column">
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isComunidadOrigenSearching">{{'Comunidad' | translate}} Origen*</mat-label>
                  <mat-label *ngIf="isComunidadOrigenSearching">Cargando...</mat-label>
                  <mat-select formControlName="ComunidadOrigenId" (selectionChange)="onSelectComunidadOrigen()">
                    <mat-option *ngFor="let s of comunidadOrigenList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="!formGroup.controls['ComunidadOrigenId'].valid && formGroup.controls['ComunidadOrigenId'].touched">
                    {{ getErrorComunidadOrigen() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div *ngIf="obraSeleccionada" fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isComunidadDestinoSearching">{{'Comunidad' | translate}} Destino*</mat-label>
                  <mat-label *ngIf="isComunidadDestinoSearching">Cargando...</mat-label>
                  <mat-select formControlName="ComunidadDestinoId">
                    <mat-option *ngFor="let s of comunidadDestinoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="!formGroup.controls['ComunidadDestinoId'].valid && formGroup.controls['ComunidadDestinoId'].touched">
                    {{ getErrorComunidadDestino() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div *ngIf="obraSeleccionada" fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isTipoMaterialSearching">{{'TipoMaterial' | translate}}*</mat-label>
                  <mat-label *ngIf="isTipoMaterialSearching">Cargando...</mat-label>
                  <mat-select [disabled]="item.PedidoItems?.length > 0 " formControlName="TipoMaterial"
                    (selectionChange)="onTipoMaterialSelect()">
                    <mat-option *ngFor="let s of tipoMaterialList" [value]="s">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="!formGroup.controls['TipoMaterial'].valid && formGroup.controls['TipoMaterial'].touched">
                    {{ getErrorTipoMaterial() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div *ngIf="obraSeleccionada" fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Observación</mat-label>
                  <input matInput formControlName="Observacion" (keyup.enter)="onGuardar()" maxlength="100">
                  <mat-error
                    *ngIf="!formGroup.controls['Observacion'].valid && formGroup.controls['Observacion'].touched">
                    {{ getErrorObservacion() }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

          </mat-expansion-panel>

        </form>

      </ng-container>

      <!-- Edicion de pedido ya creado -->
      <form [formGroup]="formGroup" *ngIf="item?.Id > 0">

        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-right: 5px;">settings</mat-icon>Datos del Pedido
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Número</b>: {{item.Id}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Estado</b>: {{item.EstadoNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>{{'Comunidad' | translate}} Origen</b>: {{item.ComunidadOrigenNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item" >
              <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!(pedidoPermisos?.CanEdit)">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>{{'Comunidad' | translate}} Destino</b>: {{item.ComunidadDestinoNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
              <mat-form-field appearance="outline" style="width: 100%" *ngIf="pedidoPermisos?.CanEdit">
                <mat-label *ngIf="!isComunidadDestinoSearching">{{'Comunidad' | translate}} Destino*</mat-label>
                <mat-label *ngIf="isComunidadDestinoSearching">Cargando...</mat-label>
                <mat-select formControlName="ComunidadDestinoId">
                  <mat-option *ngFor="let s of comunidadDestinoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
                <mat-error
                  *ngIf="!formGroup.controls['ComunidadDestinoId'].valid && formGroup.controls['ComunidadDestinoId'].touched">
                  {{ getErrorComunidadDestino() }}
                </mat-error>
              </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>{{'TipoMaterial' | translate}}</b>: {{item.TipoMaterialNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Creado por</b>: {{item.UsuarioCreacion}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="puedeVerFacturaPagada(item?.EstadoId)">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="pedidoPermisos?.CanEdit" style="margin-top: 15px;">
                  <mat-checkbox [(ngModel)]="item.Pagado" [ngModelOptions]="{standalone: true}" color="primary" (change)="detectarCambioCheckItemPagado()">Pedido pagado
                  </mat-checkbox>
                </div>
                <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!(pedidoPermisos?.CanEdit)">
                  <mat-label><b>Pedido Pagado</b>: {{item.Pagado ? 'Sí' : 'No'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="item?.Activo == false">
              <mat-expansion-panel [expanded]="true" hideToggle="true" style="background-color: indianred;">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Activo</b>: {{item.Activo ? 'Sí' : 'No'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!(pedidoPermisos?.CanEdit)">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Observación</b>: {{item.Observacion}}</mat-label>
                </div>
              </mat-expansion-panel>
              <mat-form-field appearance="outline" style="width: 100%" *ngIf="pedidoPermisos?.CanEdit">
                <mat-label>Observación</mat-label>
                <input matInput formControlName="Observacion" (keyup.enter)="onGuardar()" maxlength="100">
                <mat-error
                  *ngIf="!formGroup.controls['Observacion'].valid && formGroup.controls['Observacion'].touched">
                  {{ getErrorObservacion() }}
                </mat-error>
              </mat-form-field>
            </div>

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
              <button mat-raised-button (click)="onGuardar()" *ngIf="pedidoPermisos?.CanEdit" [disabled]="isProcessing()"
                color="primary" class="zb-button">{{isSaving ? 'Guardando...' : 'Guardar Pedido'}}</button>
            </div>

          </div>

        </mat-expansion-panel>

      </form>

      <ng-container *ngIf="puedeVerAprobaciones()">

        <br/>

        <!-- Flujo de aprobaciones -->
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-right: 5px;">check_circle_outline</mat-icon>Flujo de Aprobaciones
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <mat-label *ngIf="isPedidoAprobacionesSearching"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
          <mat-horizontal-stepper linear *ngIf="!isPedidoAprobacionesSearching" [editable]="false" [disabled]="true" class="custom-stepper">
            <mat-step label="Coordinador" [editable]="false" [disabled]="true">
              <ng-template matStepLabel>
                <mat-icon [ngStyle]="{ 'color': aprobacionCoordinador != null ? '#2b9e3a' : 'indianred' }">{{aprobacionCoordinador != null ? 'check_circle' : 'radio_button_unchecked'}}</mat-icon>
                <mat-label style="color: black; font-weight: 500;">
                  {{getAprobadorText(null, 'Coordinador')}}
                </mat-label>
              </ng-template>
            </mat-step>
            <mat-step label="Coordinador Gral." [editable]="false" [disabled]="true">
              <ng-template matStepLabel>
                <mat-icon [ngStyle]="{ 'color': aprobacionCoordinadorGeneral != null ? '#2b9e3a' : 'indianred' }">{{aprobacionCoordinadorGeneral != null ? 'check_circle' : 'radio_button_unchecked'}}</mat-icon>
                <mat-label style="color: black; font-weight: 500;">
                  {{getAprobadorText(null, 'Coordinador General')}}
                </mat-label>
              </ng-template>
            </mat-step>
            <mat-step label="CEO" [editable]="false" [disabled]="true">
              <ng-template matStepLabel>
                <mat-icon [ngStyle]="{ 'color': aprobacionCeo != null ? '#2b9e3a' : 'indianred' }">{{aprobacionCeo != null ? 'check_circle' : 'radio_button_unchecked'}}</mat-icon>
                <mat-label style="color: black; font-weight: 500;">
                  {{getAprobadorText(null, 'CEO')}}
                </mat-label>
              </ng-template>
            </mat-step>
          </mat-horizontal-stepper>

        </mat-expansion-panel>

      </ng-container>

      <br/>

      <mat-expansion-panel [expanded]="true" *ngIf="seleccionoFamiliaMaterial">

        <mat-tab-group dynamicHeight>

          <!--? materiales  -->
          <mat-tab label="Materiales" *ngIf="pedidoPermisos?.CanMaterialVer">

            <mat-expansion-panel [expanded]="true" hideToggle="true">

              <div fxLayout="row stretch" fxLayout.xs="column">
                <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin: 10px;">
                  <!-- <button mat-raised-button (click)="onGuardarMaterial()"
                    *ngIf="(item?.Id > 0) && (pedidoPermisos?.CanAddMaterial || pedidoPermisos?.CanEditMaterial || pedidoPermisos?.CanDeleteMaterial)"
                    (disabled)="isProcessing()" color="primary" style="margin-right: 5px;" class="btnSumar">{{isSavingMaterial ? 'Guardando...' : 'Guardar Materiales'}}</button> -->
                  <button mat-raised-button (click)="addMaterialItem()" *ngIf="pedidoPermisos?.CanAddMaterial"
                    (disabled)="isProcessing()" class="btnSumar">Agregar Material</button>

                  <button mat-raised-button (click)="editMaterialesFechasMasivo()"
                    *ngIf="(item?.Id > 0) && (pedidoPermisos?.CanAddMaterial || pedidoPermisos?.CanEditMaterial || pedidoPermisos?.CanDeleteMaterial)"
                    (disabled)="isProcessing()" color="primary" style="margin-left: 5px;" class="btnSumar">{{isSavingMaterial ? 'Guardando...' : 'Cambios Masivos'}}</button>

                </div>
              </div>

              <div fxLayout="row stretch" fxLayout.xs="column">
                <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                  <mat-label class="text-style" *ngIf="isPedidoItemsSearching">Buscando...</mat-label>
                  <ejs-grid #pedidoItemGrid [dataSource]='item?.PedidoItems' [allowPaging]="true" [allowSorting]="true"
                    [toolbar]='toolbarOptions' *ngIf="!isPedidoItemsSearching" [selectionSettings]='selectionOptions'
                    [pageSettings]='pageSettings' [allowResizing]='true' (rowDataBound)='rowDataBound($event)'>
                    <e-columns>
                      <e-column field='MaterialNombre' headerText='Material'></e-column>
                      <e-column field='Detalle' headerText='Detalle'></e-column>
                      <e-column field='Cantidad' headerText='Cantidad'></e-column>
                      <e-column field='RubroContableNombre' headerText='Rubro Contable'></e-column>
                      <e-column field='FechaNecesidad' headerText='Fecha Necesidad'></e-column>
                      <e-column field='FechaLimite' headerText='Fecha Límite'></e-column>
                      <e-column headerText='Acciones'></e-column>
                    </e-columns>
                    <ng-template #rowTemplate let-data>
                      <tr class="e-row">
                        <td class="e-rowcell">
                          {{data.MaterialNombre}}
                        </td>
                        <td class="e-rowcell">
                          {{data.Detalle}}
                        </td>
                        <td class="e-rowcell">
                          {{ data.Cantidad | number:'1.2-2' }} {{data.MaterialUnidadMedida}}
                        </td>
                        <td class="e-rowcell">
                          {{data.RubroContableNombre}}
                        </td>
                        <td class="e-rowcell">
                          {{ data.FechaNecesidad | date:'dd/MM/yyyy' }}
                        </td>
                        <td class="e-rowcell">
                          {{ data.FechaLimite | date:'dd/MM/yyyy' }}
                        </td>
                        <td class="e-rowcell">
                          <a style="cursor: pointer; margin-left: 18px" (click)="editMaterialItem(data)" title="Ver material">
                            <mat-icon style="width: 5px; font-size: 18px;">visibility</mat-icon>
                          </a>
                          <a style="cursor: pointer; margin-left: 16px" (click)="deleteMaterialItem(data)" *ngIf="pedidoPermisos?.CanDeleteMaterial"
                            title="Eliminar material">
                            <mat-icon style="width: 5px; font-size: 18px;">delete</mat-icon>
                          </a>
                        </td>
                      </tr>
                    </ng-template>
                  </ejs-grid>
                </div>
              </div>

            </mat-expansion-panel>

          </mat-tab>

          <!--? planificación entrega  -->
          <mat-tab label="Planificación de Entregas" *ngIf="pedidoPermisos?.CanPlanificar || pedidoPermisos?.CanPlanificarEditar">

            <mat-expansion-panel [expanded]="true" hideToggle="true">

              <div fxLayout="row stretch" fxLayout.xs="column">
                <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin: 10px;">
                  <button color="primary" mat-raised-button (click)="onGuardarPlanificacion()" *ngIf="pedidoPermisos?.CanPlanificar || pedidoPermisos?.CanPlanificarEditar"
                    (disabled)="isProcessing()" class="btnSumar">{{isSavingPlan ? 'Guardando...' : 'Guardar Planificación'}}</button>

                  <button mat-raised-button *ngIf="puedeAsociarPresupuestoAlPedidoItem()"  (click)="addPlanificacionMaterialItemMasiva()"
                    (disabled)="isProcessing()" class="btnSumar"   style="margin-left: 5px;">{{isSavingPlan ? 'Guardando...' : ' Asociar Presupuesto Masivo'}}</button>

                  <button mat-raised-button (click)="onGuardarPlanificacionMasiva()" *ngIf="pedidoPermisos?.CanPlanificar || pedidoPermisos?.CanPlanificarEditar"
                      (disabled)="isProcessing()" class="btnSumar" style="margin-left: 5px;">{{isSavingPlan ? 'Guardando...' : 'Asociar Fecha Planif. Masiva'}}</button>
                </div>
              </div>

              <div fxLayout="row stretch" fxLayout.xs="column">
                <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                  <mat-label class="text-style" *ngIf="isPedidoItemsSearching">Buscando...</mat-label>
                  <ejs-grid #pedidoItemPlanificacionGrid [dataSource]='itemPlanificacionList' [allowPaging]="true" [allowSorting]="true"
                    [toolbar]='toolbarOptions' *ngIf="!isPedidoItemsSearching" [selectionSettings]='selectionOptions'
                    [pageSettings]='pageSettings' [allowResizing]='true'>
                    <e-columns>
                      <e-column field='MaterialNombre' headerText='Material'></e-column>
                      <e-column field='Detalle' headerText='Detalle'></e-column>
                      <e-column field='Cantidad' headerText='Cantidad'></e-column>
                      <e-column field='ProveedorNombre' headerText='Proveedor'></e-column>
                      <e-column field='MonedaId' headerText='Moneda'></e-column>
                      <e-column field='Monto' headerText='Monto'></e-column>
                      <!-- <e-column field='FechaNecesidad' headerText='Fecha Necesidad'></e-column>
                      <e-column field='FechaLimite' headerText='Fecha Límite'></e-column> -->
                      <e-column field='FechaEntregaPlanificada' headerText='Fecha Entrega Planificada'></e-column>
                      <e-column headerText='Acciones'></e-column>
                    </e-columns>
                    <ng-template #rowTemplate let-data>
                      <tr class="e-row">
                        <td class="e-rowcell">
                          {{data.MaterialNombre}}
                        </td>
                        <td class="e-rowcell">
                          {{data.Detalle}}
                        </td>
                        <td class="e-rowcell">
                          {{ data.Cantidad | number:'1.2-2' }} {{data.MaterialUnidadMedida}}
                        </td>
                        <td class="e-rowcell">
                          <ng-container *ngIf="!pedidoPermisos?.CanPlanificarEditar">
                            {{ data.ProveedorNombre }}
                          </ng-container>
                          <ng-container *ngIf="pedidoPermisos?.CanPlanificarEditar">
                            <input type="text" matInput [matAutocomplete]="proveedorPlanificacion"
                              [formControl]="data.ProveedorPlanificacionFormControl" style="padding:5px; width: 85%; border: 1px solid black;">
                            <i [ngStyle]="{'display': data.IsProveedorPlanificacionAutoSearching ? 'inline-block' : 'none'}"
                              class="fa fa-spinner fa-spin" style="position: absolute; right: 0"></i>
                            <mat-autocomplete #proveedorPlanificacion="matAutocomplete" name="ProveedorPlanificacion" [displayWith]="displayProveedor"
                              (optionSelected)="onPedidoItemPlanificacionChange(data.Id, $event)">
                              <mat-option *ngFor="let s of itemPlanificacionList[getItemPlanificacionIndex(data.Id)]?.FilteredProveedorPlanificacionList" [value]="s">
                                {{s.RazonSocial }}
                              </mat-option>
                            </mat-autocomplete>
                          </ng-container>
                        </td>
                        <td class="e-rowcell">
                          <ng-container *ngIf="!pedidoPermisos?.CanPlanificarEditar">
                            {{ data.MonedaNombre }}
                          </ng-container>
                          <ng-container *ngIf="pedidoPermisos?.CanPlanificarEditar">
                            <mat-label *ngIf="isMonedaSearching">Cargando...</mat-label>
                            <mat-select [(ngModel)]="data.MonedaId" name="MonedaId" (selectionChange)="onPedidoItemPlanificacionChange(data.Id, $event)"
                              style="padding: 4px 2px; width: 90%; border: 1px black solid;">
                              <mat-option *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                            </mat-select>
                          </ng-container>
                        </td>
                        <td class="e-rowcell">
                          <ng-container *ngIf="!pedidoPermisos?.CanPlanificarEditar">
                            {{ data.Monto | number:'1.2-2' }}
                          </ng-container>
                          <ng-container *ngIf="pedidoPermisos?.CanPlanificarEditar">
                            <input type="number" matInput [(ngModel)]="data.Monto" name="Monto" maxlength="150" (change)="onPedidoItemPlanificacionChange(data.Id, $event)"
                              style="padding: 4px 2px; width: 90%; border: 1px black solid;">
                          </ng-container>
                        </td>
                        <!-- <td class="e-rowcell">
                          {{ data.FechaNecesidad | date:'dd/MM/yyyy' }}
                        </td>
                        <td class="e-rowcell">
                          {{ data.FechaLimite | date:'dd/MM/yyyy' }}
                        </td> -->
                        <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                          <input matInput [matDatepicker]="fechaEntregaPlanificadaPicker" [(ngModel)]="data.FechaEntregaPlanificada"
                            (click)="fechaEntregaPlanificadaPicker.open()" style="padding: 4px 2px; width: 90%; border: 1px black solid;"
                            (dateChange)="onPedidoItemPlanificacionChange(data.Id, $event)" name="FechaEntregaPlanificada">
                          <mat-datepicker #fechaEntregaPlanificadaPicker></mat-datepicker>
                        </td>
                        <td class="e-rowcell">
                          <a style="cursor: pointer; margin-left: 18px" (click)="editMaterialPlanificacionItem(data)" title="Ver material">
                            <mat-icon style="width: 5px; font-size: 18px;">visibility</mat-icon>
                          </a>
                          <a style="cursor: pointer; margin-left: 18px" *ngIf="puedeAsociarPresupuestoAlPedidoItem(data)" (click)="addPlanificacionMaterialItem(data)" title="Asociar presupuesto al item">
                            <mat-icon style="width: 5px; font-size: 18px;">monetization_on</mat-icon>
                          </a>
                        </td>
                      </tr>
                    </ng-template>
                  </ejs-grid>
                </div>
              </div>

            </mat-expansion-panel>

          </mat-tab>

          <!--? presupuestos  -->
          <mat-tab label="Presupuestos" *ngIf="item?.Id > 0 && pedidoPermisos?.CanPresupuestoVer">

            <mat-expansion-panel [expanded]="true" hideToggle="true">

              <div fxLayout="row stretch" fxLayout.xs="column">
                <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin: 10px;">
                  <button mat-raised-button (click)="editPresupuesto(null)" *ngIf="pedidoPermisos?.CanAddPresupuesto && !verSoloDetallesPresupuestos"
                    (disabled)="isProcessing()" class="zb-button" color="primary">Agregar Presupuesto</button>
                  <button mat-raised-button (click)="agregarComparativa()" *ngIf="pedidoPermisos?.CanAddPresupuesto && verSoloDetallesPresupuestos"
                    (disabled)="isProcessing()" class="zb-button" color="primary">Agregar Comparativa</button>
                  <button mat-raised-button (click)="onGuardarPresupuestoDetalleSeleccion()" color="warn" *ngIf="pedidoPermisos?.CanSelectPresupuesto"
                    (disabled)="isProcessing()" class="zb-button">{{isSavingPresupuestoSeleccion ? 'Guardando...' : 'Guardar Selección'}}</button>

                  <button mat-raised-button (click)="verSoloDetallesPresupuestos = true" *ngIf="!verSoloDetallesPresupuestos"
                    (disabled)="isProcessing()" class="zb-button">Ver Comparativa</button>
                  <button mat-raised-button (click)="verSoloDetallesPresupuestos = false" *ngIf="verSoloDetallesPresupuestos"
                    (disabled)="isProcessing()" class="zb-button">Ver Presupuestos</button>
                </div>
              </div>

              <div fxLayout="row stretch" fxLayout.xs="column">

                <div fxFlex=100 fxFlex.xs=100 class="flex-item">

                  <mat-label *ngIf="isPresupuestoSearching">Buscando...</mat-label>
                  <mat-label *ngIf="!isPresupuestoSearching && presupuestosMsgError.length > 0">{{presupuestosMsgError}}</mat-label>

                  <!--Comparativa - Listado por items -->
                  <ng-container *ngIf="!isPresupuestoSearching && verSoloDetallesPresupuestos">

                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label style="font-weight: bold; margin-bottom: 10px;">Comparativa de Presupuestos</mat-label>
                    </div>
                    <ejs-grid #gridPresupuestos [dataSource]='presupuestoDetalleList' [allowPaging]="true" [allowResizing]='true'
                      [allowSorting]="true" *ngIf="!isPresupuestoSearching" [selectionSettings]='selectionOptions'
                      [allowGrouping]='true' [groupSettings]='presupuestoGroupOptions' [pageSettings]='pageSettings'>
                      <e-columns>
                        <e-column field="ProveedorNombre" headerText="Proveedor"></e-column>
                        <e-column field="PresupuestoCodigo" headerText="Código"></e-column>
                        <e-column field="PedidoItemMaterial" headerText="Item Pedido"></e-column>
                        <e-column field="MaterialNombre" headerText="Material Alternativo"></e-column>
                        <e-column field="Detalle" headerText="Detalle"></e-column>
                        <e-column field="Cantidad" headerText="Cantidad" format="N2"></e-column>
                        <!-- <e-column field="MonedaNombre" headerText="Moneda"></e-column> -->
                        <e-column field="MontoUnitario" headerText="Monto">
                          <ng-template #template let-data>
                            {{data.MonedaNombre}} {{ data.MontoUnitario | number:'1.2-2' }}
                          </ng-template>
                        </e-column>
                        <e-column field="PresupuestoFormaPagoNombre" headerText="Forma de pago"></e-column>
                        <e-column field="PresupuestoObservacion" headerText="Observación"></e-column>
                        <e-column field="PresupuestoFechaEntrega" headerText="Fecha de entrega">
                          <ng-template #template let-data>
                            {{ data.PresupuestoFechaEntrega | date:'dd/MM/yyyy' }}
                          </ng-template>
                        </e-column>
                        <e-column headerText='Acciones' textAlign="center">
                          <ng-template #template let-data>
                            <a style="cursor: pointer; margin-right: 18px" (click)="editPresupuesto(data.PedidoPresupuestoId)">
                              <mat-icon style="width: 5px; font-size: 18px;" title="Ver presupuesto">visibility</mat-icon>
                            </a>
                          </ng-template>
                        </e-column>
                        <e-column headerText='Seleccionar' textAlign="center" *ngIf="puedeVerColumnaSeleccionPresupuesto(item?.EstadoId)">
                          <ng-template #template let-data>
                            <mat-checkbox [(ngModel)]="data.Seleccionado" name="Seleccionado" color="primary" title="Seleccionar presupuesto"
                              (change)="onSelectPresupuestoDetalle(data, $event)" *ngIf="pedidoPermisos?.CanSelectPresupuesto"></mat-checkbox>
                            <ng-container *ngIf="!(pedidoPermisos?.CanSelectPresupuesto)">{{data.Seleccionado ? 'Sí' : 'No'}}</ng-container>
                          </ng-template>
                        </e-column>
                      </e-columns>
                    </ejs-grid>

                  </ng-container>

                  <!--Listado por proveedor-->
                  <div [ngStyle]="{ 'display': !isPresupuestoSearching && !verSoloDetallesPresupuestos ? 'block' : 'none' }">

                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label style="font-weight: bold; margin-bottom: 10px;">Listado de Presupuestos por Proveedor</mat-label>
                    </div>
                    <ejs-grid #gridPresupuestosDetalle [dataSource]='presupuestoList' [childGrid]='presupuestoChildGrid'
                      [allowPaging]="true" [allowResizing]='false' [pageSettings]='pageSettings'
                      [allowSorting]="true">
                      <e-columns>
                        <e-column field="ProveedorNombre" headerText="Proveedor"></e-column>
                        <e-column field="PresupuestoCodigo" headerText="Código"></e-column>
                        <e-column field="FormaPagoNombre" headerText="Forma de Pago"></e-column>
                        <e-column field="Observacion" headerText="Observación"></e-column>
                        <e-column field="FechaEntrega" headerText="Fecha de Entrega" type="date" format="dd/MM/yyyy"></e-column>
                        <e-column field="MonedaNombre" headerText="Moneda"></e-column>
                        <e-column field="Monto" headerText="Monto Total" textAlign="Right" format="N2"></e-column>
                        <e-column headerText='Acciones' textAlign="center">
                          <ng-template #template let-data>
                            <a style="cursor: pointer; margin-right: 18px" (click)="editPresupuesto(data.Id)">
                              <mat-icon style="width: 5px; font-size: 18px;" title="Ver presupuesto">visibility</mat-icon>
                            </a>
                            <a style="cursor: pointer; margin-right: 8px" (click)="deletePresupuesto(data.Id)"
                              *ngIf="pedidoPermisos?.CanDeletePresupuesto">
                              <mat-icon style="width: 5px; font-size: 18px;" title="Eliminar presupuesto">delete</mat-icon>
                            </a>
                          </ng-template>
                        </e-column>
                      </e-columns>
                    </ejs-grid>
                    <ng-template #presupuestoSeleccionChildTemplate let-data>
                      <mat-checkbox [(ngModel)]="data.Seleccionado" name="Seleccionado" color="primary" title="Seleccionar presupuesto"
                        (change)="onSelectPresupuestoDetalle(data, $event)" *ngIf="pedidoPermisos?.CanSelectPresupuesto"></mat-checkbox>
                      <ng-container *ngIf="!(pedidoPermisos?.CanSelectPresupuesto)">{{data.Seleccionado ? 'Sí' : 'No'}}</ng-container>
                    </ng-template>

                  </div>

                </div>

              </div>

            </mat-expansion-panel>

          </mat-tab>

          <!--? remitos  -->
          <mat-tab label="Remitos" *ngIf="item?.Id > 0 && pedidoPermisos?.CanRemitoVer">

            <mat-expansion-panel [expanded]="true">

              <!-- <mat-expansion-panel-header>
                <mat-panel-title>
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
              </mat-expansion-panel-header> -->

              <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 15px;">

                <div fxFlex=100 fxFlex.xs=100 class="flex-item">

                  <mat-label *ngIf="isRemitoSearching">Buscando...</mat-label>
                  <mat-label *ngIf="!isRemitoSearching && remitosMsgError.length > 0">{{remitosMsgError}}</mat-label>

                  <div [ngStyle]="{ 'display': !isRemitoSearching && !verSoloDetallesPresupuestos ? 'block' : 'none' }">

                    <!-- <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label style="font-weight: bold; margin-bottom: 10px;">Listado de Remitos por Proveedor</mat-label>
                    </div> -->
                    <ejs-grid #gridRemitosDetalle [dataSource]='remitoList' [childGrid]='remitoChildGrid'
                      [allowPaging]="true" [allowResizing]='false' [pageSettings]='pageSettings'
                      [allowSorting]="true">
                      <e-columns>
                        <e-column field="ProveedorNombre" headerText="Proveedor"></e-column>
                      </e-columns>
                    </ejs-grid>
                    <ng-template #remitoAccionChildTemplate let-data>
                      <a style="cursor: pointer; margin-right: 18px" (click)="editRemito(data.PedidoRemitoId)">
                        <mat-icon style="width: 5px; font-size: 18px;" title="Ver remito">visibility</mat-icon>
                      </a>
                      <a style="cursor: pointer; margin-right: 18px" (click)="remitoAdjuntoInput.click()" *ngIf="pedidoPermisos?.CanEditRemito">
                        <mat-icon style="width: 5px; font-size: 18px;" title="Adjuntar archivo de remito">cloud_upload</mat-icon>
                        <input hidden (change)="onRemitoNewFileAttach(data.PedidoRemitoId, $event)" #remitoAdjuntoInput type="file">
                        <!-- <i *ngIf="isFileAttaching" class="fa fa-spinner fa-spin"></i> -->
                      </a>
                    </ng-template>

                  </div>

                </div>

              </div>

            </mat-expansion-panel>

          </mat-tab>

          <!--? entregas  -->
          <mat-tab label="Entregas" *ngIf="item?.Id > 0 && puedeVerEntregas(item?.EstadoId)">

            <mat-expansion-panel [expanded]="true" hideToggle="true">

              <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;">
                <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                  <button mat-raised-button (click)="onGenerarIncidenciaFaltante(null)" *ngIf="pedidoPermisos?.ShowBotonCrearIncidente" [disabled]="isProcessing()"
                    color="warn" class="zb-button">Crear Incidencia de Faltantes</button>
                  <button mat-raised-button (click)="enviarEntregado()" [disabled]="isProcessing()" *ngIf="pedidoPermisos?.ShowBotonEnviarEntregado && pedidoEntregasDto != null"
                    color="primary" class="zb-button">{{isEnviandoEntregado ? 'Procesando...' : 'Marcar Pedido como Entregado'}}</button>

                  <mat-form-field appearance="outline" style="width: 30%">
                    <mat-label>Agrupar por</mat-label>
                    <mat-select [(ngModel)]="pedidoEntregaAgrupador">
                      <mat-option value="">Ver sin agrupar</mat-option>
                      <mat-option value="PROVEEDOR">Por Proveedor</mat-option>
                      <mat-option value="MATERIAL">Por Material</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;">

                <div fxFlex=100 fxFlex.xs=100 class="flex-item">

                  <mat-label *ngIf="isPedidoEntregasSearching">Buscando...</mat-label>
                  <mat-label *ngIf="!isPedidoEntregasSearching && pedidoEntregasMsgError.length > 0">
                    {{pedidoEntregasMsgError}}</mat-label>

                  <ng-container *ngIf="pedidoEntregaAgrupador == null || pedidoEntregaAgrupador.length == 0">

                    <ejs-grid #gridEntregas [dataSource]='pedidoEntregasDto?.Materiales' [allowPaging]="true"
                      [allowSorting]="true" *ngIf="!isPedidoEntregasSearching" [selectionSettings]='selectionOptions'
                      [pageSettings]='pageSettings' [allowResizing]='true'>
                      <e-columns>
                        <e-column field="ProveedorNombre" headerText="Proveedor"></e-column>
                        <e-column field="MaterialNombre" headerText="Material"></e-column>
                        <e-column field="Detalle" headerText="Detalle"></e-column>
                        <e-column field="CantidadPedida" headerText="Solicitado"></e-column>
                        <e-column field="CantidadEntregada" headerText="Entregado"></e-column>
                        <e-column field="Diferencia" headerText="Pendiente"></e-column>
                      </e-columns>
                      <ng-template #rowTemplate let-data>
                        <tr class="e-row">
                          <td class="e-rowcell">
                            {{data.ProveedorNombre}}
                          </td>
                          <td class="e-rowcell">
                            {{data.MaterialNombre}}
                          </td>
                          <td class="e-rowcell">
                            {{data.Detalle}}
                          </td>
                          <td class="e-rowcell" style="text-align: right;">
                            {{ data.CantidadPedida | number:'1.2-2' }} {{data.MaterialUnidadMedida}}
                          </td>
                          <td class="e-rowcell" style="text-align: right;">
                            {{ data.CantidadEntregada | number:'1.2-2' }} {{data.MaterialUnidadMedida}}
                          </td>
                          <td class="e-rowcell" style="text-align: right;" [ngStyle]="{ 'background-color': data.Diferencia == 0 ? 'white' : (data.Diferencia > 0 ? '#edb1b1' : '#aae697') }">
                            {{ data.Diferencia | number:'1.2-2' }} {{data.MaterialUnidadMedida}}
                          </td>
                        </tr>
                      </ng-template>
                      <!-- <e-aggregates>
                        <e-aggregate>
                          <e-columns>
                            <e-column field="CantidadPedida" type="sum" textAlign='Right'>
                              <ng-template #footerTemplate let-data>
                                <mat-label style="text-align: right; float: right;">
                                  {{(data != null ? data.sum : 0) | number:'1.2-2'}} {{pedidoEntregasDto?.Materiales[0].MaterialUnidadMedida}}
                                </mat-label>
                              </ng-template>
                            </e-column>
                            <e-column field="CantidadEntregada" type="sum" textAlign='Right'>
                              <ng-template #footerTemplate let-data>
                                <mat-label style="text-align: right; float: right;">
                                  {{(data != null ? data.sum : 0) | number:'1.2-2'}} {{pedidoEntregasDto?.Materiales[0].MaterialUnidadMedida}}
                                </mat-label>
                              </ng-template>
                            </e-column>
                            <e-column field="Diferencia" type="sum" textAlign='Right'>
                              <ng-template #footerTemplate let-data>
                                <mat-label style="text-align: right; float: right;">
                                  {{(data != null ? data.sum : 0) | number:'1.2-2'}} {{pedidoEntregasDto?.Materiales[0].MaterialUnidadMedida}}
                                </mat-label>
                              </ng-template>
                            </e-column>
                          </e-columns>
                        </e-aggregate>
                      </e-aggregates> -->
                    </ejs-grid>

                  </ng-container>

                  <div [ngStyle]="{ 'display': pedidoEntregaAgrupador == 'PROVEEDOR' ? 'block' : 'none' }">

                    <ejs-grid #gridEntregasPorProveedor [dataSource]='pedidoEntregasDto?.AgrupadoProveedores'
                      [childGrid]='entregasPorProveedorChildGrid' [allowPaging]="true" [allowResizing]='false'
                      [pageSettings]='pageSettings' [allowSorting]="true">
                      <e-columns>
                        <e-column field="ProveedorNombre" headerText="Proveedor"></e-column>
                        <e-column field="CantidadPedida" headerText="Solicitado" textAlign='Right' format="N2"></e-column>
                        <e-column field="CantidadEntregada" headerText="Entregado" textAlign='Right' format="N2"></e-column>
                        <e-column field="Diferencia" headerText="Pendiente" textAlign='Right' format="N2"></e-column>
                        <e-column headerText="Acciones" *ngIf="pedidoPermisos?.ShowBotonCrearIncidente">
                          <ng-template #template let-data>
                            <a style="cursor: pointer; margin-right: 18px" (click)="onGenerarIncidenciaFaltante(data.ProveedorId)">
                              <mat-icon style="width: 5px; font-size: 18px;" title="Crear reclamo a proveedor">error_outline</mat-icon>
                            </a>
                          </ng-template>
                        </e-column>
                      </e-columns>
                    </ejs-grid>

                  </div>

                  <div [ngStyle]="{ 'display': pedidoEntregaAgrupador == 'MATERIAL' ? 'block' : 'none' }">

                    <ejs-grid #gridEntregasPorMaterial [dataSource]='pedidoEntregasDto?.AgrupadoMateriales'
                      [childGrid]='entregasPorMaterialChildGrid' [allowPaging]="true" [allowResizing]='false'
                      [pageSettings]='pageSettings' [allowSorting]="true">
                      <e-columns>
                        <e-column field="MaterialNombre" headerText="Material"></e-column>
                        <e-column field="CantidadPedida" headerText="Solicitado" textAlign='Right' format="N2"></e-column>
                        <e-column field="CantidadEntregada" headerText="Entregado" textAlign='Right' format="N2"></e-column>
                        <e-column field="Diferencia" headerText="Pendiente" textAlign='Right' format="N2"></e-column>
                      </e-columns>
                    </ejs-grid>

                  </div>

                </div>

              </div>

            </mat-expansion-panel>

          </mat-tab>

          <!--? incidencias  -->
          <mat-tab label="Incidencias" *ngIf="item?.Id > 0 && puedeVerIncidencias(item?.EstadoId)">

            <mat-expansion-panel [expanded]="true" hideToggle="true">

              <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;">
                <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                  <button mat-raised-button (click)="onGenerarIncidencia()" *ngIf="pedidoPermisos?.ShowBotonCrearIncidente" [disabled]="isProcessing()"
                    color="warn" class="zb-button">Generar Nuevo Incidente</button>
                </div>
              </div>

              <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;">

                <div fxFlex=100 fxFlex.xs=100 class="flex-item">

                  <mat-label *ngIf="isPedidoIncidenciasSearching">Buscando...</mat-label>
                  <mat-label *ngIf="!isPedidoIncidenciasSearching && pedidoIncidenciasMsgError.length > 0">
                    {{pedidoIncidenciasMsgError}}</mat-label>

                  <ejs-grid #gridIncidencias [dataSource]='pedidoIncidenciasList' [allowPaging]="true"
                    [allowSorting]="true" *ngIf="!isPedidoIncidenciasSearching" [selectionSettings]='selectionOptions'
                    [pageSettings]='pageSettings' [allowResizing]='true'>
                    <e-columns>
                      <e-column field='Id' headerText='#' width=30></e-column>
                      <e-column field='FechaUltimoMensaje' headerText='Fecha Ult. Actualización' type="Date" format="dd/MM/yyyy HH:mm" width=60></e-column>
                      <e-column field='IncidenciaUsuarioCategoriaNombre' headerText='Categoría' width=90></e-column>
                      <e-column field='ProveedorNombre' headerText='Proveedor' width=90></e-column>
                      <e-column field='EstadoNombre' headerText='Estado' width=90></e-column>
                      <e-column field='Asunto' headerText='Asunto' width=120></e-column>
                      <e-column headerText='Acciones' width=40>
                        <ng-template #template let-data>
                          <a style="cursor: pointer; margin-right: 18px" (click)="viewIncidencia(data.Id)">
                            <mat-icon style="width: 5px; font-size: 18px;" title="Ver incidencia">visibility</mat-icon>
                          </a>
                        </ng-template>
                      </e-column>

                    </e-columns>
                  </ejs-grid>

                </div>

              </div>

            </mat-expansion-panel>

          </mat-tab>

          <!--? adjuntos  -->
          <mat-tab [label]="item.Adjuntos?.length > 0 ? 'Adjuntos (' + item.Adjuntos.length + ')' : 'Adjuntos'">

            <mat-expansion-panel [expanded]="true">

              <!-- <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon style="margin-top: -3px;">attach_file</mat-icon> Adjuntos
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
              </mat-expansion-panel-header> -->

              <ng-container *ngIf="pedidoPermisos?.CanEdit">

                <div fxLayout="row stretch" fxLayout.xs="column">
                  <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin: 10px;">
                    <button mat-raised-button (click)="onGuardarAdjunto()" *ngIf="pedidoPermisos?.CanEdit && (item?.Id > 0)"
                      (disabled)="isProcessing()" color="primary" class="btnSumar">{{isSavingAdjunto ? 'Guardando...' : 'Guardar Adjuntos'}}</button>
                  </div>
                </div>

                <div fxLayout="row stretch" fxLayout.xs="column" *ngFor="let file of item.Adjuntos">

                  <div fxFlex=5 fxFlex.xs=5 class="flex-item" style="margin-top: 10px;">
                    <button mat-icon-button (click)="onFileAttachedDelete(file)" title="Eliminar adjunto">
                      <i class="fa fa-trash fa-1x"></i>
                    </button>
                  </div>
                  <div fxFlex=30 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>Descripción</mat-label>
                      <input (change)="cambioAdjuntos()" matInput [(ngModel)]="file.Descripcion" maxlength="150">
                    </mat-form-field>
                  </div>
                  <div fxFlex=65 fxFlex.xs=95 class="flex-item" style="margin-top: 20px;">
                    <a matLine href="{{file.UrlDocumento}}" target="_blank">{{file.NombreDocumento}}</a>
                  </div>

                </div>

                <div fxLayout="row stretch" fxLayout.xs="column">

                  <div fxFlex=5 fxFlex.xs=5 class="flex-item" style="margin-top: 10px;">
                  </div>
                  <div fxFlex=30 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>Descripción</mat-label>
                      <input (change)="cambioAdjuntos()" matInput [(ngModel)]="newFileDescripcion">
                    </mat-form-field>
                  </div>
                  <div fxFlex=65 fxFlex.xs=100 class="flex-item" style="margin-top: 10px;">
                    <button mat-icon-button matSuffix (click)="adjuntoInput.click()" [disabled]="isFileAttaching">
                      <mat-icon style="margin-right: 5px;">attach_file</mat-icon> Agregar adjunto
                    </button>
                    <input hidden (change)="onNewFileAttach($event)" #adjuntoInput type="file">
                    <mat-label *ngIf="isFileAttaching"><br /><i class="fa fa-spinner fa-spin"></i> Subiendo archivo...
                    </mat-label>
                  </div>

                </div>

              </ng-container>

              <div fxLayout="row stretch" class="zb-readonly" style="margin-top: 10px;" *ngIf="!(pedidoPermisos?.CanEdit)">

                <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;" *ngIf="isAttachmentSearching">
                  <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
                </div>
                <ejs-grid #adjuntosGrid [dataSource]='item.Adjuntos' [allowPaging]="true" [allowSorting]="true"
                  [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
                  [allowResizing]='true' *ngIf="!isAttachmentSearching">
                  <e-columns>
                    <e-column field='Descripcion' headerText='Descripción' width=80></e-column>
                    <e-column field='UrlDocumento' headerText='Adjunto'>
                      <ng-template #template let-data>
                        <a matLine href="{{data.UrlDocumento}}" target="_blank">{{data.NombreDocumento}}</a>
                      </ng-template>
                    </e-column>
                  </e-columns>
                </ejs-grid>

              </div>

            </mat-expansion-panel>

          </mat-tab>

          <!--? historial pedidos  -->
          <mat-tab label="Historial de Pedido" *ngIf="item?.Id > 0">

            <mat-expansion-panel [expanded]="true" hideToggle="true">

              <mat-expansion-panel [expanded]="false" style="margin: 10px;" *ngIf="pedidoPermisos?.CanComentar">

                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mat-icon style="margin-right: 5px;">comment</mat-icon>Agregar nuevo comentario
                  </mat-panel-title>
                  <mat-panel-description>
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <form [formGroup]="pedidoHistorialFormGroup">

                  <div fxLayout="row stretch" fxLayout.xs="column">

                    <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Detalle</mat-label>
                        <input (change)="cambioHistorial()" matInput formControlName="Descripcion" maxlength="150">
                        <mat-error
                          *ngIf="!pedidoHistorialFormGroup.controls['Descripcion'].valid && pedidoHistorialFormGroup.controls['Descripcion'].touched">
                          {{ getErrorPedidoHistorialDescripcion() }}
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="end end" class="flex-item">
                      <button mat-raised-button (click)="onGuardarPedidoHistorial()"
                        (disabled)="isProcessing()" color="primary">Agregar Comentario</button>
                    </div>

                  </div>

                </form>

              </mat-expansion-panel>

              <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;">

                <div fxFlex=100 fxFlex.xs=100 class="flex-item">

                  <mat-label *ngIf="isPedidoHistorialSearching">Buscando...</mat-label>
                  <mat-label *ngIf="!isPedidoHistorialSearching && pedidoHistorialMsgError.length > 0">
                    {{pedidoHistorialMsgError}}</mat-label>

                  <ejs-grid #gridEntregas [dataSource]='pedidoHistorialDtoList' [allowPaging]="true"
                    [allowSorting]="true" *ngIf="!isPedidoHistorialSearching" [selectionSettings]='selectionOptions'
                    [pageSettings]='pageSettings' [allowResizing]='true'>
                    <e-columns>
                      <e-column field="FechaCreacion" headerText="Fecha Creación" width="20%">
                        <ng-template #template let-data>
                          {{ data.FechaCreacion | date:'dd/MM/yyyy HH:mm' }}
                        </ng-template>
                      </e-column>
                      <e-column field="Descripcion" headerText="Detalle"></e-column>
                      <e-column field="UsuarioNombre" headerText="Usuario Creador" width="20%"></e-column>
                      <e-column width="7%">
                        <ng-template #template let-data>
                          <a (click)="onHistorialDetalleCambioClick(data)" *ngIf="data.DetalleCambios != null && data.DetalleCambios.length > 0" title="Ver detalles del cambio" style="cursor: pointer;">
                            <i class="fa fa-info fa-1x"></i>
                          </a>
                        </ng-template>
                      </e-column>
                    </e-columns>
                  </ejs-grid>

                </div>

              </div>

            </mat-expansion-panel>

          </mat-tab>

        </mat-tab-group>

      </mat-expansion-panel>

    </div>

  </mat-card-content>

  <mat-card-actions style="margin-bottom: 20px;">

    <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="space-between none">
      <div>
        <button mat-raised-button (click)="onGuardar()" *ngIf="!isSearching && pedidoPermisos?.CanEdit && !(item?.Id > 0)" [disabled]="isProcessing()"
          color="primary" class="zb-button">{{isSaving ? 'Creando...' : 'Crear Pedido'}}</button>

        <button mat-raised-button (click)="onCancel()" color="warn"
          class="zb-button">{{pedidoPermisos?.CanEdit && !(item?.Id > 0) ? 'Cancelar' : 'Cerrar'}}</button>
      </div>
      <div *ngIf="!isSearching && (item?.Id > 0)">
        <ng-container *ngIf="pedidoPermisos?.CanApprove">
          <button mat-raised-button (click)="onAprobar()" color="primary"
            class="zb-button" [disabled]="isProcessing()">{{isAprobando ? 'Aprobando...' : 'Aprobar'}}</button>
          <button *ngIf="pedidoPermisos?.CanApprove" mat-raised-button (click)="onRechazar()" color="warn"
            class="zb-button" [disabled]="isProcessing()">{{isRechazando ? 'Retrocediendo...' : 'Retroceder'}}</button>
        </ng-container>

        <button *ngIf="pedidoPermisos?.CanDelete && item.PuedeDarDeBaja" mat-raised-button (click)="onDarBaja()"
          class="zb-button" [disabled]="isProcessing()">{{isDeleting ? 'Rechazando...' : 'Rechazar'}}</button>

        <button *ngIf="pedidoPermisos?.ShowBotonEnviarPresupuestar" mat-raised-button (click)="enviarPresupuestar()"
          class="zb-button"
          [disabled]="isProcessing()">{{isEnviandoPresupuestar ? 'Procesando...' : 'Enviar a Presupuestar'}}</button>
        <button *ngIf="pedidoPermisos?.ShowBotonEnviarRevision" mat-raised-button (click)="enviarRevision()"
          class="zb-button"
          [disabled]="isProcessing()">{{isEnviandoRevision ? 'Procesando...' : 'Enviar a Revisión'}}</button>
        <button *ngIf="pedidoPermisos?.ShowBotonEnviarPendienteEntrega" mat-raised-button (click)="enviarPendienteEntrega()"
          class="zb-button"
          [disabled]="isProcessing()">{{isEnviandoPendienteEntrega ? 'Procesando...' : 'Enviar a Pendiente Entrega'}}</button>
        <button *ngIf="pedidoPermisos?.ShowBotonEnviarPendienteCoordinacion" mat-raised-button (click)="enviarPendienteCoordinacion()"
          class="zb-button"
          [disabled]="isProcessing()">{{isEnviandoPendienteCoordinacion ? 'Procesando...' : 'Enviar a Pendiente Coordinación'}}</button>

        <button *ngIf="pedidoPermisos?.ShowBotonEnviarFinalizado" mat-raised-button (click)="enviarFinalizado()"
          class="zb-button"
          [disabled]="isProcessing()">{{isEnviandoFinalizado ? 'Procesando...' : 'Enviar a Finalizado'}}</button>
      </div>
    </div>

  </mat-card-actions>

</mat-card>
